import { memo, useEffect, useState } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Lottie from 'react-lottie-player';
import * as S from './style';

interface IProps {
  value?: number | string | undefined;
  selectedValue?: number | string | undefined;
  text?: string;
  dot?: boolean;
  textColor?: string;
  className?: string;
  isAd?: boolean;
  imgSrc?: string;
  activeImgSrc?: string; // 활성화 시 노출할 이미지
  lottieData?: any;
  activeLottieData?: any; // 활성화 시 노출할 로띠
  onClick?: () => void;
}

const MainGnbMenuBarItem = ({
  value,
  selectedValue = '',
  text,
  dot,
  textColor = '',
  className,
  isAd = false,
  imgSrc,
  activeImgSrc,
  lottieData,
  activeLottieData,
  onClick,
}: IProps) => {
  const [activeValue, setActiveValue] = useState(String(value));
  const [$selectedValue, setSelectedValue] = useState(String(selectedValue));

  const cName = classNameBind([
    'menubar-item item',
    'main-gnb-item',
    activeValue === $selectedValue ? 'active' : '',
    dot ? 'dot' : '',
    className || '',
  ]);

  useEffect(() => {
    setActiveValue(String(value));
    setSelectedValue(String(selectedValue));
  }, [selectedValue, value]);

  const isActive = activeValue === $selectedValue;
  const currentLottieData =
    isActive && activeLottieData ? activeLottieData : lottieData;
  const currentImgSrc = isActive && activeImgSrc ? activeImgSrc : imgSrc;

  const renderContent = () => {
    // 로띠가 최우선
    if (currentLottieData) {
      return (
        <span className="mnbrtm-inner type-lottie">
          <Lottie loop path={currentLottieData} play />
        </span>
      );
    }

    // 그 다음 이미지
    if (currentImgSrc) {
      return (
        <span className="mnbrtm-inner type-image">
          <Img src={currentImgSrc} alt={text} fitType="contain" priority />
        </span>
      );
    }
    // 기본 text 타입 렌더링
    return <span className="mnbrtm-inner">{text}</span>;
  };

  return (
    <S.MainGnbMenuBarItem className={cName} $textcolor={textColor}>
      <Button className="area-click" onClick={onClick}>
        {renderContent()}
        {isAd && <span className="ad-tag">AD</span>}
      </Button>
    </S.MainGnbMenuBarItem>
  );
};

export default memo(MainGnbMenuBarItem);
